import {
  ENHANCE_SYSTEM_PROMPT,
  ANALYZE_IMAGE_PROMPT,
} from "./constants";

const GEMINI_URL = (key) =>
  `https://generativelanguage.googleapis.com/v1beta/models/gemini-1.5-flash:generateContent?key=${key}`;

// TEXT ENHANCEMENT (Gemini)
export const getEnhancedPrompt = async (userInput) => {
  try {
    const response = await fetch(
      GEMINI_URL(process.env.REACT_APP_GEMINI_KEY),
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          contents: [
            {
              parts: [
                {
                  text: `${ENHANCE_SYSTEM_PROMPT}\n\nUser Input: ${userInput}`,
                },
              ],
            },
          ],
        }),
      }
    );
    if (!response.ok) {
      const err = await response.json();
      throw new Error(err.error?.message || "API failed");
}

    const data = await response.json();
    return data.candidates[0].content.parts[0].text.trim();
  } catch (err) {
    console.error("Enhance Error:", err);
    return userInput; // fallback
  }
};

export const generateImage = async (prompt) => {
  try {
    const response = await fetch(
      "https://api.stability.ai/v1/generation/stable-diffusion-xl-1024-v1-0/text-to-image",
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_STABILITY_KEY}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          text_prompts: [
            { text: prompt, weight: 1 },
            { text: "blurry, low quality, distorted", weight: -1 },
          ],
          cfg_scale: 7,
          height: 1024,
          width: 1024,
          steps: 30,
          samples: 1,
        }),
      }
    );

    if (!response.ok) {
      const err = await response.json();
      throw new Error(err.message || "Stability API failed");
    }

    const data = await response.json();

   if (!data.artifacts || !data.artifacts.length) {
  throw new Error("No image returned from API");
  }
    const base64 = data.artifacts[0].base64;

    // Convert base64 → image URL
    return `data:image/png;base64,${base64}`;
  } catch (err) {
    console.error("Image Generation Error:", err);

    // fallback image
    return "https://via.placeholder.com/512?text=Image+Failed";
  }
};

// STEP 3: IMAGE ANALYSIS (Gemini Vision)
export const analyzeImage = async (base64Image) => {
  try {
    const response = await fetch(
      GEMINI_URL(process.env.REACT_APP_GEMINI_KEY),
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          contents: [
            {
              parts: [
                { text: ANALYZE_IMAGE_PROMPT },
                {
                  inline_data: {
                    mime_type: "image/jpeg",
                    data: base64Image,
                  },
                },
              ],
            },
          ],
        }),
      }
    );

    const data = await response.json();
    let text = data.candidates[0].content.parts[0].text.trim();

    // Clean markdown if exists
    text = text.replace(/```json|```/g, "").trim();

    // Safe JSON parse
    try {
      return JSON.parse(text);
    } catch {
      console.warn("JSON parse failed, using fallback");
      return {
        mainSubject: "object",
        colorPalette: ["neutral", "soft", "warm"],
        lightingStyle: "soft lighting",
        artisticStyle: "cinematic",
        mood: "calm",
        compositionNotes: "centered composition",
      };
    }
  } catch (err) {
    console.error("Analyze Error:", err);
    return {
      mainSubject: "object",
      colorPalette: ["neutral"],
      lightingStyle: "normal",
      artisticStyle: "realistic",
      mood: "neutral",
      compositionNotes: "simple composition",
    };
  }
};

// STEP 4: BUILD VARIATION PROMPT
export const buildVariationPrompt = (analysis) => {
  return `A ${analysis.artisticStyle} image of ${analysis.mainSubject}, 
with ${analysis.lightingStyle}, 
colors ${analysis.colorPalette.join(", ")}, 
mood ${analysis.mood}, 
${analysis.compositionNotes}, ultra detailed`;
};


// UTILITY: FILE → BASE64

export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const base64 = reader.result.split(",")[1];
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};
